'use client'

import { motion } from 'framer-motion'
import { Home, ArrowLeft } from 'lucide-react'
import Link from 'next/link'

export default function NotFound() {
  return (
    <main className="min-h-screen flex items-center justify-center p-4">
      <div className="max-w-4xl w-full text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="space-y-8"
        >
          <div className="space-y-4">
            <motion.h1
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="text-8xl md:text-9xl font-bold gradient-text"
            >
              404
            </motion.h1>
            
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="text-3xl md:text-4xl font-bold text-gray-800"
            >
              Page Not Found
            </motion.h2>
            
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
              className="text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed"
            >
              Sorry, we couldn&apos;t find the page you&apos;re looking for. 
              The page might have been moved, deleted, or you might have mistyped the URL.
            </motion.p>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.8 }}
            className="flex flex-col sm:flex-row justify-center gap-4 pt-8"
          >
            <Link
              href="/"
              className="px-6 py-3 bg-gradient-to-r from-primary-500 to-secondary-500 text-white rounded-full font-medium flex items-center justify-center space-x-2 hover:opacity-90 transition-opacity"
            >
              <Home className="w-5 h-5" />
              <span>Go to Homepage</span>
            </Link>
            
            <button
              onClick={() => window.history.back()}
              className="px-6 py-3 bg-gray-100 text-gray-700 rounded-full font-medium flex items-center justify-center space-x-2 hover:bg-gray-200 transition-colors"
            >
              <ArrowLeft className="w-5 h-5" />
              <span>Go Back</span>
            </button>
          </motion.div>

          {/* Helpful Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 1 }}
            className="pt-8"
          >
            <h3 className="text-lg font-semibold text-gray-800 mb-4">
              Popular Pages
            </h3>
            <div className="flex flex-wrap justify-center gap-4">
              <Link href="#products" className="text-primary-600 hover:text-primary-700 font-medium">
                Products
              </Link>
              <Link href="/blog" className="text-primary-600 hover:text-primary-700 font-medium">
                Blog
              </Link>
              <Link href="/careers" className="text-primary-600 hover:text-primary-700 font-medium">
                Careers
              </Link>
              <Link href="/press-kit" className="text-primary-600 hover:text-primary-700 font-medium">
                Press Kit
              </Link>
              <Link href="/#about" className="text-primary-600 hover:text-primary-700 font-medium">
                About
              </Link>
              <Link href="/#contact" className="text-primary-600 hover:text-primary-700 font-medium">
                Contact
              </Link>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </main>
  )
}
